document.addEventListener("DOMContentLoaded", function () {
  const root = document.getElementById("byj-builder");
  if (!root) return;

  const variantId = root.dataset.variantId;

  const title = document.getElementById("byj-title");
  const subtitle = document.getElementById("byj-subtitle");
  const education = document.getElementById("byj-education");
  const category = document.getElementById("byj-category");
  const optionsWrap = document.getElementById("byj-options");
  const progressBar = document.getElementById("byj-progress-bar");
  const summary = document.getElementById("byj-summary");
  const backBtn = document.getElementById("byj-back");
  const nextBtn = document.getElementById("byj-next");
  const addBtn = document.getElementById("byj-add");
  const phValue = document.getElementById("byj-ph-value");
  const phFill = document.getElementById("byj-ph-fill");

  let stepIndex = 0;
  const answers = {};

  const steps = [
    {
      id: "age",
      category: "General",
      title: "How old are you?",
      subtitle: "Age determines active strength and delivery approach.",
      education: "Skin cell turnover slows over time. I use age as a starting point for peptide load, renewal strength, and barrier support.",
      type: "single",
      options: [
        ["18-24", "18–24", "Gentle prevention", ["Niacinamide", "Panthenol", "Green Tea"], 5.4],
        ["25-34", "25–34", "Early intervention", ["Vitamin C", "Peptides", "Hyaluronic Acid"], 5.1],
        ["35-44", "35–44", "Active repair", ["Matrixyl Synthe'6", "GHK-Cu", "Resveratrol"], 5.2],
        ["45-54", "45–54", "Intensive renewal", ["Growth Factor Support", "Ceramide NP", "Bakuchiol"], 5.4],
        ["55+", "55+", "Deep restoration", ["Ceramide Complex", "Peptides", "Squalane"], 5.6]
      ]
    },
    {
      id: "gender",
      category: "General",
      title: "Biological sex",
      subtitle: "Hormonal profile influences oil production, collagen density, and sensitivity.",
      education: "This is not marketing. It helps calibrate sebum, barrier support, and active delivery.",
      type: "single",
      options: [
        ["male", "Male", "Higher sebum, thicker dermis", ["Oil-Balancing Niacinamide", "Lightweight Delivery System"], 5.2],
        ["female", "Female", "Hormonal cycling, thinner dermis", ["Barrier Support", "Peptide Complex"], 5.4],
        ["prefer-not", "Prefer not to say", "We’ll calibrate from other answers", ["Adaptive Base"], 5.3]
      ]
    },
    {
      id: "ethnicity",
      category: "Skin",
      title: "What is your skin tone?",
      subtitle: "This helps prevent irritation and post-inflammatory hyperpigmentation.",
      education: "Higher Fitzpatrick types need more careful acid and retinoid strategy to avoid unwanted dark marks.",
      type: "single",
      options: [
        ["type-i-ii", "Very light to light", "Higher photoaging risk", ["Vitamin C", "Ferulic Acid"], 3.4],
        ["type-iii", "Medium", "Balanced brightening approach", ["Niacinamide", "Tranexamic Acid"], 5.1],
        ["type-iv", "Olive", "PIH-conscious brightening", ["Tranexamic Acid", "Azelaic Acid"], 5.3],
        ["type-v-vi", "Brown to deep", "Highest PIH protection strategy", ["Azelaic Acid", "Licorice Root", "Niacinamide"], 5.4]
      ]
    },
    {
      id: "concern",
      category: "Skin",
      title: "Primary skin concern?",
      subtitle: "This determines the hero actives in your custom treatment serum.",
      education: "The hero concern sets the formula direction. Secondary concerns are layered in without causing ingredient conflict.",
      type: "single",
      options: [
        ["hyperpigmentation", "Dark spots & uneven tone", "Tone correction and melanin pathway support", ["Tranexamic Acid", "Niacinamide", "Azelaic Acid", "Licorice Root"], 5.2],
        ["acne", "Acne & breakout-prone skin", "Pore clearing without stripping", ["Salicylic Acid", "Azelaic Acid", "Zinc PCA", "Centella"], 4.2],
        ["aging", "Fine lines & firmness", "Peptides, renewal, collagen support", ["Matrixyl Synthe'6", "Argireline", "GHK-Cu", "Growth Factor Support"], 5.4],
        ["sensitivity", "Redness & sensitivity", "Barrier repair and calming support", ["Centella", "Panthenol", "Ceramide NP", "Beta-Glucan"], 5.6]
      ]
    },
    {
      id: "contact",
      category: "Profile",
      title: "Who am I formulating for?",
      subtitle: "This attaches your profile to the routine in cart.",
      education: "Your formula profile follows the order so the routine can be blended fresh.",
      type: "input"
    },
    {
      id: "skin-type",
      category: "Skin",
      title: "How does your skin behave?",
      subtitle: "This shapes the base: gel, serum, emulsion, or cream.",
      education: "The vehicle matters as much as the actives. The wrong base can make great ingredients perform poorly.",
      type: "single",
      options: [
        ["oily", "Oily / acne-prone", "Lightweight oil-free delivery", ["Niacinamide", "Zinc PCA", "Pentylene Glycol"], 5.2],
        ["dry", "Dry / dehydrated", "Lipid-rich hydration support", ["Ceramide NP", "Squalane", "Hyaluronic Acid"], 5.6],
        ["combination", "Combination", "Balanced adaptive emulsion", ["Betaine", "Panthenol", "Light Ceramide Complex"], 5.4],
        ["normal", "Normal / resilient", "Flexible active access", ["Hyaluronic Acid", "Peptides"], 5.3]
      ]
    },
    {
      id: "hair-type",
      category: "Hair",
      title: "What’s your hair type?",
      subtitle: "Curl pattern and density determine weight, slip, and conditioning load.",
      education: "Fine hair needs weightless support. Coily hair usually needs more moisture, slip, and lipid conditioning.",
      type: "single",
      options: [
        ["straight-fine", "Straight & fine", "Lift without residue", ["Rice Protein", "Panthenol"], 5.5],
        ["straight-thick", "Straight & thick", "More conditioning load", ["Amino Acid Complex", "Argan Oil"], 5.4],
        ["wavy", "Wavy", "Definition without heaviness", ["Aloe", "Lightweight Conditioning Polymer"], 5.3],
        ["curly", "Curly", "Moisture and frizz control", ["Shea Ester", "Amino Acid Complex"], 5.2],
        ["coily", "Coily / kinky", "Maximum moisture and slip", ["Rich Conditioning Complex", "Jojoba", "Panthenol"], 5.2]
      ]
    },
    {
      id: "scalp-condition",
      category: "Hair",
      title: "How’s your scalp?",
      subtitle: "Your shampoo should treat scalp first and hair second.",
      education: "Scalp condition determines surfactant strength, soothing support, and exfoliation strategy.",
      type: "single",
      options: [
        ["oily-scalp", "Oily / greasy", "Gets oily within 24 hours", ["Zinc PCA", "Willow Bark"], 5.1],
        ["dry-flaky", "Dry / flaky", "Flakes or tightness", ["Aloe", "Panthenol", "Prebiotic Support"], 5.6],
        ["sensitive-scalp", "Sensitive / irritated", "Itching or redness", ["Bisabolol", "Centella", "Oat Extract"], 5.7],
        ["balanced-scalp", "Balanced", "Comfortable between washes", ["Green Tea", "Panthenol"], 5.4]
      ]
    },
    {
      id: "body-concerns",
      category: "Body",
      title: "What body concerns should I address?",
      subtitle: "Choose all that apply.",
      education: "Body care should be facial-grade, but adjusted for thicker skin, friction, shaving, and larger surface area.",
      type: "multi",
      options: [
        ["kp-texture", "KP / rough bumps", "Texture and keratosis pilaris support", ["Lactic Acid", "Urea", "Niacinamide"], 4.2],
        ["body-hyperpigmentation", "Dark spots / uneven tone", "Tone correction", ["Tranexamic Acid", "Licorice Root", "Azelaic Acid"], 5.2],
        ["body-firmness", "Firmness & smoothing", "Elasticity support", ["Peptides", "Caffeine", "CoQ10"], 5.4],
        ["ingrowns", "Ingrowns / razor bumps", "Post-shave calming", ["Salicylic Acid", "Centella", "Allantoin"], 4.4],
        ["body-dryness", "Extreme dryness", "Barrier repair", ["Urea", "Ceramides", "Squalane"], 5.7]
      ]
    },
    {
      id: "sensitivities",
      category: "Safety",
      title: "Any sensitivities or safety considerations?",
      subtitle: "I’ll exclude these and swap to safer alternatives.",
      education: "This is where the formula becomes safer than off-the-shelf skincare.",
      type: "multi",
      options: [
        ["retinoids", "Retinoids", "Avoid vitamin A derivatives", ["Bakuchiol Alternative"], 5.5],
        ["aha-bha", "AHAs / BHAs", "Avoid exfoliating acids", ["PHA Alternative", "Enzyme Support"], 5.6],
        ["vitamin-c", "Vitamin C", "Avoid direct vitamin C", ["Resveratrol", "Niacinamide"], 5.5],
        ["fragrance", "Fragrance", "No scent materials", ["Fragrance-Free Base"], 5.4],
        ["pregnant", "Pregnant / breastfeeding", "Auto-swap contraindicated actives", ["Pregnancy-Conscious Active Set"], 5.6],
        ["none", "No sensitivities", "Full ingredient access", ["Full Active Access"], 5.2]
      ]
    },
    {
      id: "scent-profile",
      category: "Finish",
      title: "Choose your scent identity",
      subtitle: "Skincare stays fragrance-free. Hair and body can carry your signature.",
      education: "This lets the routine feel personal without compromising facial skin tolerance.",
      type: "single",
      options: [
        ["warm-woody", "Warm & woody", "Sandalwood, cedar, amber", ["Warm Woody Accord"], 5.4],
        ["fresh-citrus", "Fresh & citrus", "Bergamot, grapefruit, green tea", ["Fresh Citrus Accord"], 5.3],
        ["floral-soft", "Floral & soft", "Jasmine, rose, white musk", ["Soft Floral Accord"], 5.4],
        ["herbal-earthy", "Herbal & earthy", "Lavender, rosemary, sage", ["Herbal Earth Accord"], 5.4],
        ["unscented", "Fragrance-free everything", "Maximum clinical purity", ["Fragrance-Free Finish"], 5.5]
      ]
    }
  ];

  function answerArray(id) {
    const value = answers[id];
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  }

  function optionLabel(stepId, optionId) {
    const step = steps.find(s => s.id === stepId);
    const opt = step?.options?.find(o => o[0] === optionId);
    return opt ? opt[1] : optionId || "";
  }

  function selectedOptions() {
    const selected = [];
    steps.forEach(step => {
      answerArray(step.id).forEach(id => {
        const opt = step.options?.find(o => o[0] === id);
        if (opt) selected.push({ step, opt });
      });
    });
    return selected;
  }

  function getIngredients() {
    const map = new Map();

    selectedOptions().forEach(({ opt }) => {
      const ingredients = opt[3] || [];
      ingredients.forEach(name => {
        if (!map.has(name)) map.set(name, 1);
        else map.set(name, map.get(name) + 1);
      });
    });

    const sens = answerArray("sensitivities");

    if (sens.includes("pregnant")) {
      map.delete("Retinol");
      map.delete("Retinal");
      map.delete("Salicylic Acid");
      map.set("Pregnancy-Conscious Renewal Alternative", 1);
    }

    if (sens.includes("vitamin-c")) {
      map.delete("Vitamin C");
      map.delete("L-Ascorbic Acid");
      map.set("Vitamin C-Free Brightening System", 1);
    }

    if (sens.includes("aha-bha")) {
      map.delete("Lactic Acid");
      map.delete("Salicylic Acid");
      map.set("Acid-Free Smoothing System", 1);
    }

    if (sens.includes("fragrance")) {
      map.delete("Warm Woody Accord");
      map.delete("Fresh Citrus Accord");
      map.delete("Soft Floral Accord");
      map.delete("Herbal Earth Accord");
      map.set("Fragrance-Free Finish", 1);
    }

    return Array.from(map.keys());
  }

  function getPh() {
    const selected = selectedOptions();
    if (!selected.length) return 5.2;

    const vals = selected.map(s => s.opt[4]).filter(Boolean);
    const avg = vals.reduce((a, b) => a + b, 0) / vals.length;

    return Math.max(3.2, Math.min(6.2, avg)).toFixed(1);
  }

  function getFormulaId() {
    const seed = JSON.stringify(answers).split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return `BYJ-${String(seed).slice(-4).padStart(4, "0")}`;
  }

  function render() {
    const step = steps[stepIndex];
    const progress = ((stepIndex + 1) / steps.length) * 100;

    progressBar.style.width = `${progress}%`;
    category.textContent = `${step.category} · Step ${stepIndex + 1} of ${steps.length}`;
    title.textContent = step.title;
    subtitle.textContent = step.subtitle;
    education.textContent = step.education;
    optionsWrap.innerHTML = "";

    if (step.type === "input") {
      optionsWrap.innerHTML = `
        <div class="byj-input-group">
          <input id="byj-name" type="text" placeholder="First name" value="${answers.firstName || ""}">
          <input id="byj-email" type="email" placeholder="Email address" value="${answers.email || ""}">
        </div>
      `;
    } else {
      step.options.forEach(opt => {
        const [id, label, desc, ingredients] = opt;
        const selected = answerArray(step.id).includes(id);

        const card = document.createElement("div");
        card.className = `byj-option ${selected ? "active" : ""}`;
        card.innerHTML = `
          <strong>${label}</strong>
          <span>${desc}</span>
          <small>Adds: ${(ingredients || []).join(", ")}</small>
        `;

        card.addEventListener("click", () => {
          if (step.type === "multi") {
            let arr = answerArray(step.id);

            if (id === "none") {
              arr = ["none"];
            } else {
              arr = arr.filter(v => v !== "none");
              arr = arr.includes(id) ? arr.filter(v => v !== id) : [...arr, id];
            }

            answers[step.id] = arr;
          } else {
            answers[step.id] = id;
          }

          render();
        });

        optionsWrap.appendChild(card);
      });
    }

    backBtn.disabled = stepIndex === 0;
    nextBtn.textContent = stepIndex === steps.length - 1 ? "Review Formula" : "Next";
    addBtn.disabled = stepIndex !== steps.length - 1;

    updateSummary();
  }

  function updateSummary() {
    const ingredients = getIngredients();
    const ph = getPh();
    const phPercent = ((ph - 3) / 4) * 100;

    phValue.textContent = ph;
    phFill.style.width = `${Math.max(8, Math.min(100, phPercent))}%`;

    summary.innerHTML = `
      <div class="byj-summary-card">
        <strong>Formula ID</strong>
        <span>${getFormulaId()}</span>
      </div>

      <div class="byj-summary-card">
        <strong>Ingredients Added</strong>
        ${
          ingredients.length
            ? ingredients.map(i => `<span class="byj-pill">${i}</span>`).join("")
            : `<span>Choose answers to begin adding actives.</span>`
        }
      </div>

      <div class="byj-summary-card">
        <strong>AM Routine</strong>
        <span>Cleanser → Personalized Vitamin C / Antioxidant Serum → Moisturizer</span>
      </div>

      <div class="byj-summary-card">
        <strong>PM Routine</strong>
        <span>Cleanser → Custom Treatment Serum → Moisturizer</span>
      </div>

      <div class="byj-summary-card">
        <strong>Hair + Body</strong>
        <span>Hair and body actives are calibrated from the same intake so the entire routine works as one system.</span>
      </div>

      <div class="byj-summary-card">
        <strong>Cadence</strong>
        <span>60-day personalized routine · formulated fresh by Jimmy</span>
      </div>
    `;
  }

  nextBtn.addEventListener("click", () => {
    const step = steps[stepIndex];

    if (step.type === "input") {
      answers.firstName = document.getElementById("byj-name")?.value || "";
      answers.email = document.getElementById("byj-email")?.value || "";
    }

    if (stepIndex < steps.length - 1) {
      stepIndex++;
      render();
      window.scrollTo({ top: root.offsetTop, behavior: "smooth" });
    } else {
      updateSummary();
    }
  });

  backBtn.addEventListener("click", () => {
    if (stepIndex > 0) {
      stepIndex--;
      render();
      window.scrollTo({ top: root.offsetTop, behavior: "smooth" });
    }
  });

  addBtn.addEventListener("click", () => {
    if (!variantId) {
      alert("Please select a routine product in the BYJ Builder section settings.");
      return;
    }

    const properties = {
      "Formula ID": getFormulaId(),
      "Client Name": answers.firstName || "",
      "Client Email": answers.email || "",
      "Target pH": getPh(),
      "Primary Concern": optionLabel("concern", answers.concern),
      "Skin Type": optionLabel("skin-type", answers["skin-type"]),
      "Skin Tone": optionLabel("ethnicity", answers.ethnicity),
      "Ingredients Added": getIngredients().join(", "),
      "Routine Cadence": "60 days",
      "_BYJ Full Intake": JSON.stringify(answers)
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties
      })
    })
      .then(res => {
        if (!res.ok) throw new Error("Cart add failed");
        window.location.href = "/cart";
      })
      .catch(() => {
        alert("Something went wrong adding the routine to cart.");
      });
  });

  render();
});